import { render, staticRenderFns } from "./CenterEdit.vue?vue&type=template&id=44ca15ef&scoped=true&"
import script from "./CenterEdit.vue?vue&type=script&lang=js&"
export * from "./CenterEdit.vue?vue&type=script&lang=js&"
import style0 from "./CenterEdit.vue?vue&type=style&index=0&id=44ca15ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca15ef",
  null
  
)

export default component.exports